import { render, staticRenderFns } from "./CompanyEvaluation.vue?vue&type=template&id=a13e9d3c&"
import script from "./CompanyEvaluation.vue?vue&type=script&lang=js&"
export * from "./CompanyEvaluation.vue?vue&type=script&lang=js&"
import style0 from "./CompanyEvaluation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "packages/cb-components-suitability/src/components/main/CompanyEvaluation.vue"
export default component.exports